import Link from 'next/link';

import * as CS from './styled';

export interface IRuleCardProps {
    title: string,
    desc: string,
    link?: {
        text: string,
        path: string,
    },
}

const RuleCard = ({ title, desc, link }: IRuleCardProps): JSX.Element => {
    return (
        <CS.CardWrapper>
            <CS.CardTitle>{title}</CS.CardTitle>
            <CS.CardDescription>{desc}</CS.CardDescription>
            {link &&
                <Link href={link.path} passHref>
                    <CS.CardLink>{link.text}</CS.CardLink>
                </Link>
            }
        </CS.CardWrapper>
    );
};

export default RuleCard;
